function __createShopifyClient(storeDomain, apiVersion, token) {
    if (typeof ShopifyStorefrontAPIClient === 'undefined') {
        console.error('>>> ShopifyStorefrontAPIClient is not defined on the page');
        return null;
    }

    return ShopifyStorefrontAPIClient.createStorefrontApiClient({
        storeDomain: storeDomain,
        apiVersion: apiVersion,
        publicAccessToken: token
    });
}

async function __getProductById(productId) {
    let productQuery = `
        query {
          node(id: "gid://shopify/ProductVariant/${productId}") {
            ... on ProductVariant {
              id
              title
              price {
                amount
                currencyCode
              }
              product {
                title
                handle
              }
            }
          }
        }
    `;

    return productQuery;
}

async function __executeFetch(client,query) {
    const response = await client.fetch(query);

    if (!response.ok) {
        return false;
    }

    const {errors, data, extensions} = await response.json();

    if (errors && errors.length) {
        console.log(">>> ERROR: ", errors[0].message);
        return false;
    }

    if (data) {
        return data;
    }

    return false;
}